module.exports = __webpack_public_path__ + "static/media/uber-image.1e9fcff9.jpg";